import {parseGid} from 'utilities/common';
import {DeliveryEstimates} from 'utilities/delivery-promise';
import {ProductDetails} from 'utilities/product';
import {ErrorLoggerInput, ReportType} from 'utilities/error-logger/types';

const WIDGET_LOAD_EVENT_NAME = 'bwp_widget_load';

interface Props {
  deliveryEstimate: DeliveryEstimates;
  productDetails: ProductDetails;
  variantId: number;
  reportError: (input: ErrorLoggerInput) => void;
}

export function widgetLoadWebPixel({
  deliveryEstimate,
  productDetails,
  variantId,
  reportError,
}: Props) {
  const variant = productDetails.variants.find(
    (variant) => variant.id === variantId,
  );
  const sku = variant?.sku;
  const amount = variant?.price;
  const currencyCode = window?.ShopifyAnalytics?.meta?.currency;
  const productId = productDetails.id;
  const minDeliveryTime =
    deliveryEstimate.selectedShippingOption?.minDeliveryTime;
  const maxDeliveryTime =
    deliveryEstimate.selectedShippingOption?.maxDeliveryTime;
  let apiClientId;
  try {
    apiClientId = parseGid(
      deliveryEstimate.selectedShippingOption?.deliveryPromiseProviderAppId ||
        '',
    );
  } catch (error) {
    reportError({
      severity: ReportType.Investigate,
      error,
      message: `Failed to pares gid from deliveryPromiseProviderAppId`,
    });
  }

  if (apiClientId) {
    window.Shopify?.analytics?.publish(
      WIDGET_LOAD_EVENT_NAME,
      {
        deliveryEstimate: {
          minDeliveryTime,
          maxDeliveryTime,
        },
        sku,
        price: {
          amount,
          currencyCode,
        },
        productVariantId: variantId.toString(),
        productId,
      },
      {sendTo: apiClientId},
    );
  }
}
